import {FormRule} from "antd";
import {ReactElement} from "react";

export const formRules: Record<string, (customMessage?: string | ReactElement) => FormRule[]> = {
  PASSWORD: (customMessage) => [
    {
      required: true,
      pattern:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]).{8,}$/,
      message:
        customMessage ||
        'Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.',
    }
  ],
  EMAIL: (customMessage) => [
    {
      type: 'email',
      message: customMessage || 'Please input a valid email!',
    },
  ]
}